import React from "react";
import FamilyTravelCTALanding from "../components/FamilyTravelCTALanding";
import TestimonialView from "../components/TestimonialView";
import CruiseHeaderLanding from "../components/CruiseHeaderLanding";
import CruiseDetailLanding from "../components/CruiseDetailLanding";
import FixCruiseLanding from "../components/FixCruiseLanding";
import PlanningTrip from "../components/PlanningTrip";
import Footer from "../components/Footer";

import banner from "../assets/images/CruiseHeader.jpg"; // you can change this per page
import Clients from "../components/Clients";
import TestimonialLanding from "../components/TestimonialLanding";

const CruiseLanding: React.FC = () => {
  return (
    <div>
      <CruiseHeaderLanding
        bannerImage={banner}
        bannerText="Where the Journey Is the Destination: Explore the World by Water"
      />
      <CruiseDetailLanding />
      <FixCruiseLanding />
      <TestimonialLanding />
      <FamilyTravelCTALanding />
      <PlanningTrip
        headingplanning="Start Planning Your Family Adventure"
        paragraph="Let us take care of the details while you enjoy quality time with your Family."
      />
      <Clients />
      <Footer />
    </div>
  );
};

export default CruiseLanding;
